module.exports = new __parcel__URL__("sunflower.ff291a55.svg").toString();